<div class="entries-editor">
  <!-- Section Header with Add Button -->
  <div class="entries-header">
    <div class="header-text">
      <h4 *ngIf="sectionLabel">{{ sectionLabel }}</h4>
      <p class="hint-text" *ngIf="hintText">{{ hintText }}</p>
    </div>
    <ion-button
      *ngIf="!disabled && subjectID > 0 && scheduleID > 0"
      class="add-button"
      color="secondary"
      fill="outline"
      size="small"
      (click)="addEntry()">
      <ion-icon name="add" slot="start"></ion-icon>
      {{ 'WORK_SCHEDULE.Add_Entry' | translate }}
    </ion-button>
  </div>

  <!-- Loading State -->
  <div class="loading" *ngIf="isLoading">
    <ion-spinner name="crescent"></ion-spinner>
  </div>

  <!-- Entries List -->
  <div class="entries-list" *ngIf="!isLoading && entries.length > 0">
    <ion-list>
      <ion-item *ngFor="let entry of entries" class="entry-item">
        <ion-label>
          <h2>{{ getEntryDescription(entry) }} <span class="time-range">{{ getEntryTimeRange(entry) }}</span></h2>
          <p *ngIf="entry.notes" class="notes">{{ entry.notes }}</p>
        </ion-label>
        <ion-buttons slot="end" *ngIf="!disabled">
          <ion-button fill="clear" (click)="editEntry(entry)">
            <ion-icon name="create-outline" slot="icon-only"></ion-icon>
          </ion-button>
          <ion-button fill="clear" color="danger" (click)="deleteEntry(entry)">
            <ion-icon name="trash-outline" slot="icon-only"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-item>
    </ion-list>
  </div>

  <!-- Empty State - has schedule but no entries -->
  <div class="no-entries" *ngIf="!isLoading && entries.length === 0 && scheduleID > 0">
    <p>{{ 'WORK_SCHEDULE.No_Local_Entries' | translate }}</p>
  </div>

  <!-- Not configured state - no schedule available -->
  <div class="no-entries" *ngIf="!isLoading && scheduleID <= 0">
    <p>{{ 'WORK_SCHEDULE.No_Schedule_Selected' | translate }}</p>
  </div>
</div>
